(function () {
  const forms = document.querySelectorAll('.js-formspree-form');

  forms.forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      const successMessage = form.querySelector('.landing-form-success');
      const errorMessage = form.querySelector('.landing-form-error');
      const submitButton = form.querySelector('button[type="submit"]');
      const submitText = submitButton ? submitButton.textContent : '';

      if (successMessage) successMessage.hidden = true;
      if (errorMessage) errorMessage.hidden = true;

      if (!form.action || !form.action.includes('formspree.io/f/')) {
        if (errorMessage) errorMessage.hidden = false;
        return;
      }

      form.classList.add('is-loading');
      if (submitButton) {
        submitButton.textContent = 'Küldés...';
      }

      try {
        const response = await fetch(form.action, {
          method: 'POST',
          body: new FormData(form),
          headers: {
            Accept: 'application/json',
          },
        });

        if (!response.ok) {
          throw new Error('Formspree request failed');
        }

        form.classList.add('is-submitted');
        form.reset();

        if (successMessage) {
          successMessage.hidden = false;
          successMessage.focus({ preventScroll: true });
        }
      } catch (error) {
        if (errorMessage) {
          errorMessage.hidden = false;
          errorMessage.focus({ preventScroll: true });
        }
      } finally {
        form.classList.remove('is-loading');
        if (submitButton) {
          submitButton.textContent = submitText;
        }
      }
    });
  });
})();
